export default function handleRestriction({ graphql, props, state }) {
  const { accept, id } = props
  const orderId = state.get('orderHistory.currentId')

  graphql.mutate(`{
        handleAttest(orderItemId: "${id}", accept: ${accept}, orderId: "${orderId}")
      }`)
}



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/actions/handleAttest.js